import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="tech-grid bg-navy-950 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-194" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-195" data-mp="2vqhhugko801z">
        <div className="text-center" data-id="element-196" data-mp="2vppm95r2q2bp">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-197" data-mp="2voo7aq6xsvop">
            ¿Te suena conocido esto?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-navy-50" data-id="element-198" data-mp="35frca32zlut9">
            Domingo a las 11 de la noche. Mañana tienes clase de gestión ambiental. Y todavía estás buscando cómo
            explicar la diferencia entre residuos reciclables y no reciclables, cómo funcionan los ecosistemas o por qué
            el cambio climático es importante sin que tus alumnos se duerman o no entiendan nada.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-navy-200" data-id="element-199" data-mp="jd3ocq7rcfsh">
            No es tu culpa. Es que llevas años peleando con materiales desorganizados, teoría densa en libros viejos y
            recursos pensados para otros contextos que después tienes que reescribir entero.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-navy-700 bg-navy-900 p-6 sm:p-8" data-id="element-200" data-mp="x51q2fz539em">
          <p className="mb-5 inline-flex items-center gap-2 font-display text-xl font-bold text-white" data-id="element-201" data-mp="1c1j093vlehzl">
            <AlertTriangleIcon className="h-5 w-5 text-sun-400" aria-hidden="true" data-id="element-202" data-mp="1g3nsby6e76k4" />
            El costo de no tener el material correcto:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-203" data-mp="3dviadlwzatap">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-navy-50" data-id="element-204" data-mp="3hwtr11xvk46r">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-500" aria-hidden="true" data-id="element-205" data-mp="p0it7l7dtrne" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-206" data-mp="y29wykid3oem">
          <p className="text-lg font-bold text-leaf-400" data-id="element-207" data-mp="tzlls666e5eh">
            Basta de regalar tu tiempo libre. Tu dedicación ya la tienes. Ahora te falta la herramienta.
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-208" data-mp="17ws45zmzm236">
            Planifica todo tu año <span className="text-sun-400" data-id="element-209" data-mp="1hoy1zpzx7dqa">hoy.</span>
          </p>
        </div>
      </div>
    </section>;
}